declare module "@mui/material/styles" {
    interface PaletteColor {
        100: string;
        200: string;
        300: string;
        400: string;
        500: string;
        red: string;
        purple: string;
        yellow: string;
    }
}

export const primary = {
    50: "#e2f5ed",
    100: "#b9e5d1",
    200: "#8adab5",
    300: "#52c498",
    400: "#08b783",
    500: "#00aa6d",
    600: "#009b62",
    700: "#008955",
    800: "#007848",
    900: "#005932",
    main: "#00aa6d",
    light: "#D3F5FE",
    dark: "#007848",
    red: "#FF6B93",
    purple: "#A798FF",
    yellow: "#FF9777",
};

export const secondary = {
    100: "#F9F9F9",
    200: "#ECEFF5",
    300: "#E5EAF2", // outline or border
    400: "#005932", // text muted
    500: "#005932", // main text
    main: "#005932", // main text
    light: "#F9F9F9",
    red: "#FF6B93",
    purple: "#A798FF",
    yellow: "#FF9777",
};

export const error = {
    50: "#FFBFBF",
    100: "#FF9999",
    200: "#FF7373",
    300: "#FF4D4D",
    400: "#FF2626",
    500: "#FF0000",
    600: "#CC0000",
    700: "#A60000",
    800: "#800000",
    900: "#590000",
};

export const success = {
    main: "#2CC5BD",
};

export const warning = {
    main: "#FFE91F",
    dark: "#FFD600",
};

export const info = {
    main: "#A798FF",
};

export const text = {
    primary: secondary[500],
    secondary: secondary[400],
    disabled: secondary[300],
};
